/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Refund_Policy__Refunds__Processing_TimeInputs */

const en_help_center__refund_policy__refunds__processing_time = /** @type {((inputs: Help_Center__Refund_Policy__Refunds__Processing_TimeInputs) => LocalizedString) & { parts: (inputs: Help_Center__Refund_Policy__Refunds__Processing_TimeInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Help_Center__Refund_Policy__Refunds__Processing_TimeInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Processing Time: Approved refunds are processed within 5-7 business days to your original payment method.`)
		}),
		{
			parts: /** @type {(inputs: Help_Center__Refund_Policy__Refunds__Processing_TimeInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "strong", options: {}, attributes: {} }, { type: "text", value: "Processing Time:" }, { type: "markup-end", name: "strong", options: {}, attributes: {} }, { type: "text", value: " Approved refunds are processed within " }, { type: "markup-start", name: "strong", options: {}, attributes: {} }, { type: "text", value: "5-7 business days" }, { type: "markup-end", name: "strong", options: {}, attributes: {} }, { type: "text", value: " to your original payment method." }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "Processing Time: Approved refunds are processed within 5-7 business days to your original payment method." |
*
* @param {Help_Center__Refund_Policy__Refunds__Processing_TimeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__refund_policy__refunds__processing_time = /** @type {((inputs?: Help_Center__Refund_Policy__Refunds__Processing_TimeInputs, options?: { locale?: "en" }) => LocalizedString) & { parts: (inputs?: Help_Center__Refund_Policy__Refunds__Processing_TimeInputs, options?: { locale?: "en" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Help_Center__Refund_Policy__Refunds__Processing_TimeInputs, { locale?: "en" }, { strong: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Help_Center__Refund_Policy__Refunds__Processing_TimeInputs, options?: { locale?: "en" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			return en_help_center__refund_policy__refunds__processing_time(inputs)
		}),
		{
			parts: /** @type {(inputs?: Help_Center__Refund_Policy__Refunds__Processing_TimeInputs, options?: { locale?: "en" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				return typeof en_help_center__refund_policy__refunds__processing_time.parts === "function" ? en_help_center__refund_policy__refunds__processing_time.parts(inputs) : [{ type: "text", value: en_help_center__refund_policy__refunds__processing_time(inputs) }]
			})
		}
	)
);